module.exports = __webpack_public_path__ + "static/media/_Autogiro.bab38ab6.scss";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Cob/views/Autogiro/odin/_Autogiro.scss
// module id = 452
// module chunks = 0